import type { AppConfig } from '../../src/utils/baseConfig';

export const config: Partial<AppConfig> = {
    tenantName: 'Solana',
    enableNativeBridge: false,
};